/* 所有日志上报方法放在这里 */
import {
  enterServerReport,
  roleUpdateReport,
  clickReport,
  roleCreateReport,
  roleCreateSuccessReport,
  enterGameReport,
  attributeReport as attributeReportApi
} from "@/api/log";
import { setStorage, getStorage } from '@/libs/utils'
import { cpsOnActive } from '@/libs/business/cpsReport'

export default {
  namespaced: true,
  state: {
    list: [],
    currentBusiness: {},
    hasTab: false
  },
  actions: {
    // 进入创角界面上报
    roleCreateReport({ rootState }, roleInfo) {
      const { device_info, appkey, user_id, game_version, extra_data } = rootState.user
      const _extraData = JSON.parse(extra_data);
      roleCreateReport({
        ...device_info,
        device_id_second: device_info.android_id || device_info.idfv,
        appkey: appkey,
        device_time: device_info.time,
        deviceType: device_info.devicetype,
        user_id: user_id,
        gameVersion: game_version,
        role_id: roleInfo.roleId,
        role_name: roleInfo.roleName,
        server_id: roleInfo.serverId,
        server_name: roleInfo.serverName,
        channel: device_info.channelid,
        extra_data: extra_data,
        android_uuid: _extraData.android_uuid || "",
        oaid: _extraData.oaid || "",
        imei: _extraData.imei || "",
        android_id: _extraData.android_id || "",
        idfa: _extraData.idfa || "",
        idfv: _extraData.idfv || "",
        appkey_version_code: _extraData.appkey_version_code || "",
      })
    },
    // 进入服务器上报
    enterServerReport({ rootState }) {
      const {
        user: { appkey, user_id }
      } = rootState;
      enterServerReport({ jh_app_id: appkey, user_id });
    },
    // GS后台进入服务器上报
    enterServerGSReport({ rootState }, roleInfo) {
      const { device_info, appkey, user_id, game_version, extra_data } = rootState.user
      const _extraData = JSON.parse(extra_data);
      enterGameReport({
        ...device_info,
        device_id_second: device_info.android_id || device_info.idfv,
        appkey: appkey,
        device_time: device_info.time,
        deviceType: device_info.devicetype,
        user_id: user_id,
        gameVersion: game_version,
        role_id: roleInfo.roleId,
        role_name: roleInfo.roleName,
        server_id: roleInfo.serverId,
        extra_data: extra_data,
        server_name: roleInfo.serverName,
        channel: device_info.channelid,
        android_uuid: _extraData.android_uuid || "",
        oaid: _extraData.oaid || "",
        imei: _extraData.imei || "",
        android_id: _extraData.android_id || "",
        idfa: _extraData.idfa || "",
        idfv: _extraData.idfv || "",
        appkey_version_code: _extraData.appkey_version_code || "",
      })
    },
    // 角色升级上报
    roleUpdateReport({ rootState }, roleInfo) {
      const {
        user: { user_id, appkey, session_id, extra_data, device_info, game_version }
      } = rootState;
      const _extraData = JSON.parse(extra_data);
      roleUpdateReport({
        user_id,
        appkey: appkey,
        server_id: roleInfo.serverId,
        server_name: roleInfo.serverName,
        role_id: roleInfo.roleId,
        role_name: roleInfo.roleName,
        role_level: roleInfo.roleLevel,
        guild: roleInfo.partyName,
        money: roleInfo.balance,
        access_token: session_id,
        extra_data: extra_data,
        device_id: device_info.device_id,
        device_id_second: device_info.android_id || device_info.idfv,
        device_type: device_info.devicetype,
        network: device_info.network,
        device_time: device_info.time,
        game_version: game_version,
        appkey_version_code: _extraData.appkey_version_code || "",
      });
    },
    // GS后台创角成功上报
    roleCreateSuccessReport({ rootState }, roleInfo) {
      const { device_info, appkey, user_id, game_version, extra_data } = rootState.user
      const _extraData = JSON.parse(extra_data);
      roleCreateSuccessReport({
        ...device_info,
        device_id_second: device_info.android_id || device_info.idfv,
        appkey: appkey,
        device_time: device_info.time,
        deviceType: device_info.devicetype,
        user_id: user_id,
        gameVersion: game_version,
        role_id: roleInfo.roleId,
        role_name: roleInfo.roleName,
        server_id: roleInfo.serverId,
        server_name: roleInfo.serverName,
        extra_data: extra_data,
        channel: device_info.channelid,
        android_uuid: _extraData.android_uuid || "",
        oaid: _extraData.oaid || "",
        imei: _extraData.imei || "",
        android_id: _extraData.android_id || "",
        idfa: _extraData.idfa || "",
        idfv: _extraData.idfv || "",
        appkey_version_code: _extraData.appkey_version_code || "",
      })
    },
    // 广告点击事件数据上报
    clickReport({ rootState }, clickType) {
      const { user: { user_id, appkey } } = rootState;
      clickReport({
        user_id: user_id,
        appkey: appkey,
        activity_name: clickType.activity_name,
        click_type: clickType.click_type
      })
    },
    // 激活上报(ios买包用)
    async attributeReport({ rootState }) {
      if (localStorage.getItem('attributeReportParams')) return;

      const { device_info, appkey, extra_data } = rootState.user
      const _extraData = JSON.parse(extra_data);
      try {
        await attributeReportApi({            
          what: 'attribute',
          appid: appkey,
          op: device_info.op,
          time: device_info.time,
          devicetype: device_info.devicetype,
          channelid: device_info.channelid,
          device_id: device_info.device_id || _extraData.imei,
          uuid: device_info.uuid,
          transactionid: device_info.transactionid,
          resolution: device_info.resolution,
          os: device_info.os,
          zfmenttype: device_info.zfmenttype,
          bundleid: device_info.bundleid,
          inip: device_info.inip,
          istablet: device_info.istablet,
          sdkVersion: device_info.sdkVersion,
          idfv: device_info.idfv,
          zftype: device_info.zftype,
          network: device_info.network,
          who: device_info.who,
          osversion: device_info.osversion,
          currencyamount: device_info.currencyamount,
          wifiname: device_info.wifiname,
          android_uuid: _extraData.android_uuid || "",
          oaid: _extraData.oaid || "",
          imei: _extraData.imei || "",
          android_id: _extraData.android_id || "",
          idfa: _extraData.idfa || "",
          appkey_version_code: _extraData.appkey_version_code || "", 
        });         
      } catch (r) {
        if (r.code == '0') {
          localStorage.setItem('attributeReportParams', true);
        }
      }
    },
    async cpsOnActiveReport({ rootState }) {
      const cpsChannel = localStorage.getItem('cpsChannel')
      cpsOnActive[cpsChannel] && cpsOnActive[cpsChannel](rootState.user);
    }
  }
};
